(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soma-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-soma-cart-drawer]');
  if(!root || root.dataset.somaInit){ return; }
  root.dataset.somaInit = '1';

  var panel = root.querySelector('[data-soma-panel]');
  var overlay = root.querySelector('[data-soma-overlay]');
  var body = root.querySelector('[data-soma-body]');
  var foot = root.querySelector('[data-soma-foot]');
  var countEl = root.querySelector('[data-soma-count]');
  var subEl = root.querySelector('[data-soma-subtotal]');
  var fmt = root.getAttribute('data-money-format') || "{{amount}}";
  var CART_URL = root.getAttribute('data-cart-url') || '/cart';
  var CHANGE_URL = root.getAttribute('data-cart-change-url') || '/cart/change.js';
  var ROOT_URL = root.getAttribute('data-root-url') || '/';

  function esc(s){ var d=document.createElement('div'); d.textContent = (s==null?'':String(s)); return d.innerHTML; }

  function formatMoney(cents){
    if(typeof cents === 'string'){ cents = cents.replace('.',''); }
    function fwd(number, precision, thousands, decimal){
      precision = (precision==null) ? 2 : precision;
      thousands = (thousands==null) ? ',' : thousands;
      decimal = (decimal==null) ? '.' : decimal;
      if(isNaN(number)||number==null){ return '0'; }
      number = (number/100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+thousands);
      var c = parts[1] ? (decimal+parts[1]) : '';
      return dollars + c;
    }
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(re);
    var key = match ? match[1] : 'amount';
    var value;
    switch(key){
      case 'amount': value = fwd(cents,2); break;
      case 'amount_no_decimals': value = fwd(cents,0); break;
      case 'amount_with_comma_separator': value = fwd(cents,2,'.',','); break;
      case 'amount_no_decimals_with_comma_separator': value = fwd(cents,0,'.',','); break;
      case 'amount_with_space_separator': value = fwd(cents,2,' ',','); break;
      case 'amount_no_decimals_with_space_separator': value = fwd(cents,0,' ',''); break;
      default: value = fwd(cents,2);
    }
    return fmt.replace(re, value);
  }

  function render(cart){
    if(countEl){ countEl.textContent = '(' + cart.item_count + ')'; }
    if(!cart.items || cart.items.length === 0){
      body.innerHTML = '<div class="soma-drawer__empty"><p>Таны сагс хоосон байна.</p><a href="'+ROOT_URL+'">Дэлгүүр рүү буцах</a></div>';
      if(foot){ foot.setAttribute('hidden',''); }
      return;
    }
    var html = '';
    cart.items.forEach(function(it, idx){
      var line = idx + 1;
      var img = it.image ? '<div class="soma-li__img"><img src="'+it.image+'" alt="'+esc(it.product_title)+'" width="72" height="72" loading="lazy"></div>' : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="soma-li__variant">'+esc(it.variant_title)+'</p>' : '';
      html += '<div class="soma-li" data-line="'+line+'">'
        + img
        + '<div class="soma-li__info">'
          + '<p class="soma-li__title">'+esc(it.product_title)+'</p>'
          + vt
          + '<div class="soma-li__row">'
            + '<div class="soma-li__qty">'
              + '<button type="button" data-line-minus aria-label="Хасах">&minus;</button>'
              + '<span>'+it.quantity+'</span>'
              + '<button type="button" data-line-plus aria-label="Нэмэх">+</button>'
            + '</div>'
            + '<span class="soma-li__price">'+formatMoney(it.final_line_price)+'</span>'
          + '</div>'
          + '<button type="button" class="soma-li__remove" data-line-remove>Хасах</button>'
        + '</div>'
      + '</div>';
    });
    body.innerHTML = html;
    if(subEl){ subEl.textContent = formatMoney(cart.total_price); }
    if(foot){ foot.removeAttribute('hidden'); }
  }

  function getCart(){
    return fetch(CART_URL + '.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); });
  }
  function changeLine(line, qty){
    panel.classList.add('is-busy');
    return fetch(CHANGE_URL, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ return r.json(); }).then(function(cart){
      panel.classList.remove('is-busy'); render(cart);
    }).catch(function(){ panel.classList.remove('is-busy'); });
  }

  var lastFocus = null;
  function openCart(){
    lastFocus = document.activeElement;
    overlay.removeAttribute('hidden');
    requestAnimationFrame(function(){ overlay.classList.add('is-open'); panel.classList.add('is-open'); });
    panel.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('soma-drawer-open');
    getCart().then(render);
  }
  function closeCart(){
    overlay.classList.remove('is-open'); panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('soma-drawer-open');
    setTimeout(function(){ overlay.setAttribute('hidden',''); }, 280);
    if(lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
  }

  // close handlers
  root.querySelectorAll('[data-soma-close]').forEach(function(b){ b.addEventListener('click', closeCart); });
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && panel.classList.contains('is-open')){ closeCart(); } });

  // line item qty / remove (event delegation)
  body.addEventListener('click', function(e){
    var li = e.target.closest('.soma-li'); if(!li){ return; }
    var line = parseInt(li.getAttribute('data-line'), 10);
    var span = li.querySelector('.soma-li__qty span');
    var cur = span ? parseInt(span.textContent, 10) : 1;
    if(e.target.closest('[data-line-plus]')){ changeLine(line, cur + 1); }
    else if(e.target.closest('[data-line-minus]')){ changeLine(line, Math.max(0, cur - 1)); }
    else if(e.target.closest('[data-line-remove]')){ changeLine(line, 0); }
  });

  // open via product ATC event
  document.addEventListener('soma:open-cart', openCart);

  // open via any cart link (header icon, etc.) instead of navigating
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href]'); if(!a){ return; }
    var href = a.getAttribute('href'); if(!href){ return; }
    var path = href.split('?')[0].replace(/\/+$/,'');
    if(/\/cart$/.test(path)){ e.preventDefault(); openCart(); }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soma-product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    var form = root.querySelector('[data-soma-form]');
    if(!form) return;
    var addUrl = form.getAttribute('data-cart-add');
    var cartUrl = form.getAttribute('data-cart-url');

    var main = root.querySelector('[data-soma-main]');
    root.querySelectorAll('[data-soma-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        var src = t.getAttribute('data-src');
        if(main && src){ main.src = src; }
        root.querySelectorAll('[data-soma-thumb]').forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    var qty = form.querySelector('[name="quantity"]');
    root.querySelectorAll('[data-q]').forEach(function(b){
      b.addEventListener('click', function(){
        var v = parseInt(qty.value, 10) || 1;
        v += (b.getAttribute('data-q') === '+' ? 1 : -1);
        if(v < 1){ v = 1; }
        qty.value = v;
      });
    });

    var priceEl = root.querySelector('[data-soma-price]');
    var compareEl = root.querySelector('[data-soma-compare]');
    var stickyPrice = root.querySelector('[data-soma-sticky-price]');
    function setSticky(val){ if(stickyPrice && val){ stickyPrice.textContent = val; } }
    function syncSticky(){ if(stickyPrice && priceEl){ stickyPrice.textContent = priceEl.textContent; } }

    form.querySelectorAll('input[name="id"]').forEach(function(r){
      r.addEventListener('change', function(){
        root.querySelectorAll('.soma-pack, .soma-tier').forEach(function(p){ p.classList.remove('is-active'); });
        var lab = r.closest('.soma-pack, .soma-tier');
        if(lab){ lab.classList.add('is-active'); }
        if(priceEl && r.dataset.price){ priceEl.textContent = r.dataset.price; }
        if(compareEl){ compareEl.textContent = (r.dataset.compare && r.dataset.compare !== r.dataset.price) ? r.dataset.compare : ''; }
        if(r.dataset.price){ setSticky(r.dataset.price); }
        syncSticky();
      });
    });
    var checked = form.querySelector('input[name="id"]:checked');
    if(checked && checked.dataset.price){ setSticky(checked.dataset.price); } else { syncSticky(); }

    var busy = false;
    function addToCart(){
      if(busy){ return; }
      busy = true;
      var btns = root.querySelectorAll('.soma-atc');
      btns.forEach(function(b){ b.classList.add('is-loading'); b.setAttribute('disabled','disabled'); });
      var fd = new FormData(form);
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(function(res){
        return res.json().then(function(json){ return { ok: res.ok, json: json }; });
      }).then(function(out){
        if(!out.ok){ throw out.json; }
        var drawer = document.querySelector('[data-soma-cart-drawer]');
        if(drawer){
          busy = false;
          btns.forEach(function(b){ b.classList.remove('is-loading'); b.removeAttribute('disabled'); });
          document.dispatchEvent(new CustomEvent('soma:open-cart'));
        } else {
          window.location.href = cartUrl;
        }
      }).catch(function(){
        busy = false;
        btns.forEach(function(b){ b.classList.remove('is-loading'); b.removeAttribute('disabled'); });
        form.submit();
      });
    }

    form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });
    root.querySelectorAll('[data-sticky-atc], [data-soma-cta]').forEach(function(b){
      b.addEventListener('click', function(){ addToCart(); });
    });
  }

  function boot(){ document.querySelectorAll('[data-soma-pp]').forEach(initRoot); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('[data-soma-pp]');
    if(r){ initRoot(r); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
